import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import Logo from '../../components/Logo/Logo';
import confirmVisitAPI from '../../services/api/confirmVisit';
import {
  StyledButton,
  StyledButtonGroup,
  StyledContainer,
  StyledMessage,
  StyledDivRow,
  StyledError,
} from './Visit.style';

const baseUrl = process.env.REACT_APP_SITE_URL;

const Visit = (): JSX.Element | null => {
  const [isRescheduleVisit, setIsRescheduleVisit] = useState<boolean>(false);
  const [confirmVisitStatus, setConfirmVisitStatus] = useState<number>();
  const [resText, setResText] = useState<string>('');
  const [resErrorText, setResErrorText] = useState<string>('');
  const { visitId } = useParams();
  const { t } = useTranslation(['visit', 'misc']);

  const { data, status } = useQuery({
    queryKey: ['visit'],
    queryFn: () => confirmVisitAPI.getConfirmVisit(visitId as string),
    onError(error: AxiosError) {
      setConfirmVisitStatus(error?.response?.status);
    },
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const { mutate: mutateCancel } = useMutation(confirmVisitAPI.cancelVisit, {
    onSuccess: () => {
      setResText(t('visit:cancelSuccess'));
    },
    onError: (error: AxiosError) => {
      setResErrorText(error?.response?.data?.message);
    },
  });

  const { mutate: mutateReschedule } = useMutation(
    confirmVisitAPI.cancelVisit,
    {
      onSuccess: () => {
        setResText(t('visit:cancelSuccess'));
        window.location.replace(`${baseUrl}/it/affitto/${data?.property_id}`);
      },
      onError: (error: AxiosError) => {
        setResErrorText(error?.response?.data?.message);
      },
    },
  );

  return (
    <StyledContainer>
      <Logo defaultType="tenant" />
      {status === 'success' && !isRescheduleVisit && !resText && (
        <StyledButtonGroup>
          <StyledButton
            variant="secondary"
            user="tenant"
            onClick={() => mutateCancel(visitId as string)}
          >
            {t('visit:cancelVisit')}
          </StyledButton>
          <StyledButton
            variant="secondary"
            user="tenant"
            onClick={() => setIsRescheduleVisit(true)}
          >
            {t('visit:rescheduleVisit')}
          </StyledButton>
        </StyledButtonGroup>
      )}
      {status === 'success' && isRescheduleVisit && !resText && (
        <div>
          <StyledMessage>{t('visit:rescheduleContinue')}</StyledMessage>
          <StyledDivRow>
            <StyledButton
              variant="secondary"
              user="tenant"
              onClick={() => setIsRescheduleVisit(false)}
            >
              {t('misc:cancel')}
            </StyledButton>
            <StyledButton
              variant="secondary"
              user="tenant"
              onClick={() => mutateReschedule(visitId as string)}
            >
              {t('misc:confirm')}
            </StyledButton>
          </StyledDivRow>
        </div>
      )}
      {confirmVisitStatus === 400 && (
        <StyledError>{t('visit:verifiedVisit')}</StyledError>
      )}
      {confirmVisitStatus === 404 && (
        <StyledError>{t('visit:noVisit')}</StyledError>
      )}
      {confirmVisitStatus === 500 && (
        <StyledError>{t('visit:wrong')}</StyledError>
      )}
      {resText && <StyledMessage>{resText}</StyledMessage>}
      {resErrorText && <StyledError>{resErrorText}</StyledError>}
    </StyledContainer>
  );
};
export default Visit;
